import { useState } from 'react';
import { Button, Icon, Text } from 'shell/components';

const ButtonDemo = () => {
    const [isLoading, setIsLoading] = useState(false);

    const toggleLoading = () => {
        setIsLoading(true);
        setTimeout(() => setIsLoading(false), 3000);
    };

    return (
        <>
            <Text variant={'sh1'}>Button</Text>

            <Button size={'small'}>Small Primary Button</Button>
            <Button size={'medium'}>Medium Primary Button</Button>
            <Button size={'large'}>Large Primary Button</Button>

            <Button loading={isLoading} onClick={toggleLoading}>
                Loading Demo
            </Button>
            <Button loading={isLoading} startIcon={<Icon kind={'add'} />} loadingGrow onClick={toggleLoading}>
                Loading Demo
            </Button>

            <Button>Primary Button</Button>
            <Button startIcon={<Icon kind={'add'} />}>Primary Button</Button>
            <Button endIcon={<Icon kind={'add'} />}>Primary Button</Button>
            <Button disabled>Disabled Primary Button</Button>
            <Button disabled startIcon={<Icon kind={'add'} />}>
                Disabled Primary Button
            </Button>
            <Button disabled endIcon={<Icon kind={'add'} />}>
                Disabled Primary Button
            </Button>

            <Button variant={'secondary'}>Secondary Button</Button>
            <Button startIcon={<Icon kind={'add'} />} variant={'secondary'}>
                Secondary Button
            </Button>
            <Button endIcon={<Icon kind={'add'} />} variant={'secondary'}>
                Secondary Button
            </Button>
            <Button disabled variant={'secondary'}>
                Disabled Secondary Button
            </Button>
            <Button disabled startIcon={<Icon kind={'add'} />} variant={'secondary'}>
                Disabled Secondary Button
            </Button>
            <Button disabled endIcon={<Icon kind={'add'} />} variant={'secondary'}>
                Disabled Secondary Button
            </Button>

            <Button color={'neutral'} variant={'secondary'}>
                Neutral Secondary Button
            </Button>
            <Button color={'neutral'} startIcon={<Icon kind={'add'} />} variant={'secondary'}>
                Neutral Secondary Button
            </Button>
            <Button color={'neutral'} endIcon={<Icon kind={'add'} />} variant={'secondary'}>
                Neutral Secondary Button
            </Button>
            <Button color={'neutral'} disabled variant={'secondary'}>
                Disabled Neutral Secondary Button
            </Button>
            <Button color={'neutral'} disabled startIcon={<Icon kind={'add'} />} variant={'secondary'}>
                Disabled Neutral Secondary Button
            </Button>
            <Button color={'neutral'} disabled endIcon={<Icon kind={'add'} />} variant={'secondary'}>
                Disabled Neutral Secondary Button
            </Button>

            <Button variant={'tertiary'}>Tertiary Button</Button>
            <Button startIcon={<Icon kind={'add'} />} variant={'tertiary'}>
                Tertiary Button
            </Button>
            <Button endIcon={<Icon kind={'add'} />} variant={'tertiary'}>
                Tertiary Button
            </Button>
            <Button disabled variant={'tertiary'}>
                Disabled Tertiary Button
            </Button>
            <Button disabled startIcon={<Icon kind={'add'} />} variant={'tertiary'}>
                Disabled Tertiary Button
            </Button>
            <Button disabled endIcon={<Icon kind={'add'} />} variant={'tertiary'}>
                Disabled Tertiary Button
            </Button>

            <Button color={'neutral'} variant={'tertiary'}>
                Neutral Tertiary Button
            </Button>
            <Button color={'neutral'} startIcon={<Icon kind={'add'} />} variant={'tertiary'}>
                Neutral Tertiary Button
            </Button>
            <Button color={'neutral'} endIcon={<Icon kind={'add'} />} variant={'tertiary'}>
                Neutral Tertiary Button
            </Button>
            <Button color={'neutral'} disabled variant={'tertiary'}>
                Disabled Neutral Tertiary Button
            </Button>
            <Button color={'neutral'} disabled startIcon={<Icon kind={'add'} />} variant={'tertiary'}>
                Disabled Neutral Tertiary Button
            </Button>
            <Button color={'neutral'} disabled endIcon={<Icon kind={'add'} />} variant={'tertiary'}>
                Disabled Neutral Tertiary Button
            </Button>

            <Button variant={'borderless'}>Primary Borderless Button</Button>
            <Button startIcon={<Icon kind={'add'} />} variant={'borderless'}>
                Primary Borderless Button
            </Button>
            <Button endIcon={<Icon kind={'add'} />} variant={'borderless'}>
                Primary Borderless Button
            </Button>
            <Button disabled variant={'borderless'}>
                Disabled Primary Borderless Button
            </Button>
            <Button disabled startIcon={<Icon kind={'add'} />} variant={'borderless'}>
                Disabled Primary Borderless Button
            </Button>
            <Button disabled endIcon={<Icon kind={'add'} />} variant={'borderless'}>
                Disabled Primary Borderless Button
            </Button>

            <Button color={'neutral'} variant={'borderless'}>
                Neutral Borderless Button
            </Button>
            <Button color={'neutral'} startIcon={<Icon kind={'add'} />} variant={'borderless'}>
                Neutral Borderless Button
            </Button>
            <Button color={'neutral'} endIcon={<Icon kind={'add'} />} variant={'borderless'}>
                Neutral Borderless Button
            </Button>
            <Button color={'neutral'} disabled variant={'borderless'}>
                Disabled Neutral Borderless Button
            </Button>
            <Button color={'neutral'} disabled startIcon={<Icon kind={'add'} />} variant={'borderless'}>
                Disabled Neutral Borderless Button
            </Button>
            <Button color={'neutral'} disabled endIcon={<Icon kind={'add'} />} variant={'borderless'}>
                Disabled Neutral Borderless Button
            </Button>

            <Button color={'destructive'}>Primary Destructive Button</Button>
            <Button color={'destructive'} startIcon={<Icon kind={'add'} />}>
                Primary Destructive Button
            </Button>
            <Button color={'destructive'} endIcon={<Icon kind={'add'} />}>
                Primary Destructive Button
            </Button>
            <Button color={'destructive'} disabled>
                Disabled Primary Destructive Button
            </Button>
            <Button color={'destructive'} disabled startIcon={<Icon kind={'add'} />}>
                Disabled Primary Destructive Button
            </Button>
            <Button color={'destructive'} disabled endIcon={<Icon kind={'add'} />}>
                Disabled Primary Destructive Button
            </Button>

            <Button color={'destructive'} variant={'secondary'}>
                Secondary Destructive Button
            </Button>
            <Button color={'destructive'} startIcon={<Icon kind={'add'} />} variant={'secondary'}>
                Secondary Destructive Button
            </Button>
            <Button color={'destructive'} endIcon={<Icon kind={'add'} />} variant={'secondary'}>
                Secondary Destructive Button
            </Button>
            <Button color={'destructive'} disabled variant={'secondary'}>
                Disabled Secondary Destructive Button
            </Button>
            <Button color={'destructive'} disabled startIcon={<Icon kind={'add'} />} variant={'secondary'}>
                Disabled Secondary Destructive Button
            </Button>
            <Button color={'destructive'} disabled endIcon={<Icon kind={'add'} />} variant={'secondary'}>
                Disabled Secondary Destructive Button
            </Button>

            <Button color={'destructive'} variant={'tertiary'}>
                Tertiary Destructive Button
            </Button>
            <Button color={'destructive'} startIcon={<Icon kind={'add'} />} variant={'tertiary'}>
                Tertiary Destructive Button
            </Button>
            <Button color={'destructive'} endIcon={<Icon kind={'add'} />} variant={'tertiary'}>
                Tertiary Destructive Button
            </Button>
            <Button color={'destructive'} disabled variant={'tertiary'}>
                Disabled Tertiary Destructive Button
            </Button>
            <Button color={'destructive'} disabled startIcon={<Icon kind={'add'} />} variant={'tertiary'}>
                Disabled Tertiary Destructive Button
            </Button>
            <Button color={'destructive'} disabled endIcon={<Icon kind={'add'} />} variant={'tertiary'}>
                Disabled Tertiary Destructive Button
            </Button>

            <Button color={'destructive'} variant={'borderless'}>
                Borderless Destructive Button
            </Button>
            <Button color={'destructive'} startIcon={<Icon kind={'add'} />} variant={'borderless'}>
                Borderless Destructive Button
            </Button>
            <Button color={'destructive'} endIcon={<Icon kind={'add'} />} variant={'borderless'}>
                Borderless Destructive Button
            </Button>
            <Button color={'destructive'} disabled variant={'borderless'}>
                Disabled Borderless Destructive Button
            </Button>
            <Button color={'destructive'} disabled startIcon={<Icon kind={'add'} />} variant={'borderless'}>
                Disabled Borderless Destructive Button
            </Button>
            <Button color={'destructive'} disabled endIcon={<Icon kind={'add'} />} variant={'borderless'}>
                Disabled Borderless Destructive Button
            </Button>

            <Button color={'success'} variant={'secondary'}>
                Success Button
            </Button>
            <Button color={'success'} startIcon={<Icon kind={'add'} />} variant={'secondary'}>
                Success Button
            </Button>
            <Button color={'success'} endIcon={<Icon kind={'add'} />} variant={'secondary'}>
                Success Button
            </Button>
            <Button color={'success'} disabled variant={'secondary'}>
                Disabled Success Button
            </Button>
            <Button color={'success'} disabled startIcon={<Icon kind={'add'} />} variant={'secondary'}>
                Disabled Success Button
            </Button>
            <Button color={'success'} disabled endIcon={<Icon kind={'add'} />} variant={'secondary'}>
                Disabled Success Button
            </Button>
        </>
    );
};

export default ButtonDemo;
